import Axios from "axios";
import { ApiBaseUrl, LoanBaseUrl, Wizard } from "../config/config";
import { ApiResultModel } from "../models/common.model";
import {
  RegisterLoanBySupplierRequest,
  RegisterLoanBySupplierResponse,
  ReferenceKeyRequest,
  ActivateLoanRequestBySupplierResponse,
  GetSupplierAttachmentsRequest,
  DeleteSupplierAttachmentRequest,
  UploadSupplierAttachmentRequest,
  GetLoanDetailRequest,
  GetLoanDetailResponse,
  GetLoansRequest,
  GetCustomerRegistrationInfoRequest,
  GetCustomerRegistrationInfoResponse,
  CancelLoanRequestBySupplierRequest,
  UploadSupplierAttachmentResponse,
  SendLoanActivationCodeToCustomerResponse,
  GetLoanRegistrationWizardInfoResponse,
  Filter,
  CancelReason,
  GetCoreInformationResponse,
} from "../models/loan.model";
import {
  ICalculateLoanParamsRequest,
  ICalculateLoanParamsResponse,
  IfilterLoan,
  IGetLoansRequest,
  IGetLoansResponse,
  IInitializeRegistrationParamsResponse,
  ILoanBaseModel,
  IloanTemplateDetail,
  IRequestRegisterLoan,
  TGetLoanInfo,
} from "../models/loanNew.Model";
import { IResponse } from "../models/dropdown.model";

export const registerLoanBySupplier = (
  data: RegisterLoanBySupplierRequest
): Promise<ApiResultModel<RegisterLoanBySupplierResponse>> => {
  return Axios.post<ApiResultModel<RegisterLoanBySupplierResponse>>(
    ApiBaseUrl + LoanBaseUrl + "/RegisterLoanBySupplier",
    data
  ).then((result) => {
    return result.data;
  });
};

export const sendLoanActivationCodeToCustomer = (
  data: ReferenceKeyRequest
): Promise<SendLoanActivationCodeToCustomerResponse> => {
  return Axios.post<ApiResultModel<SendLoanActivationCodeToCustomerResponse>>(
    ApiBaseUrl + LoanBaseUrl + "/SendLoanActivationCodeToCustomer",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const activateLoanRequestBySupplier = (
  data: ReferenceKeyRequest
): Promise<ApiResultModel<ActivateLoanRequestBySupplierResponse>> => {
  return Axios.post<ApiResultModel<ActivateLoanRequestBySupplierResponse>>(
    ApiBaseUrl + LoanBaseUrl + "/ActivateLoanRequestBySupplier",
    data
  ).then((result) => {
    return result.data;
  });
};

export const getSupplierAttachments = (
  data: GetSupplierAttachmentsRequest
): Promise<UploadSupplierAttachmentResponse[]> => {
  return Axios.post<ApiResultModel<UploadSupplierAttachmentResponse[]>>(
    ApiBaseUrl + LoanBaseUrl + "/GetSupplierAttachments",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const deleteSupplierAttachment = (
  data: DeleteSupplierAttachmentRequest
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + LoanBaseUrl + "/DeleteSupplierAttachment",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const uploadSupplierAttachment = (
  data: UploadSupplierAttachmentRequest
): Promise<UploadSupplierAttachmentResponse> => {
  const formData = new FormData();
  if (data.LoanRequestId)
    formData.append("LoanRequestId", data.LoanRequestId.toString());
  formData.append("DocumentType", data.DocumentType!.toString());
  if (data.FileData) formData.append("FileName", data.FileData.name);
  if (data.FileData) formData.append("FileData", data.FileData);
  return Axios.post<ApiResultModel<UploadSupplierAttachmentResponse>>(
    ApiBaseUrl + LoanBaseUrl + "/UploadSupplierAttachment",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data; charset=utf-8",
      },
    }
  ).then((result) => {
    return result.data.data;
  });
};

export const getLoanDetail = (
  data: GetLoanDetailRequest
): Promise<GetLoanDetailResponse> => {
  return Axios.post<ApiResultModel<GetLoanDetailResponse>>(
    ApiBaseUrl + LoanBaseUrl + "/GetLoanDetail",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const getLoans = (
  data: GetLoansRequest
): Promise<ApiResultModel<GetLoanDetailResponse[]>> => {
  return Axios.post<ApiResultModel<GetLoanDetailResponse[]>>(
    ApiBaseUrl + LoanBaseUrl + "/GetLoans",
    data
  ).then((result) => {
    return result.data;
  });
};
export const exportLoans = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + LoanBaseUrl + "/ExportLoans",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `لیست تسهیلات.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};
export const getCustomerRegistrationInfo = (
  data: GetCustomerRegistrationInfoRequest
): Promise<GetCustomerRegistrationInfoResponse> => {
  return Axios.post<ApiResultModel<GetCustomerRegistrationInfoResponse>>(
    ApiBaseUrl + LoanBaseUrl + "/GetCustomerRegistrationInfo",
    data
  ).then((result) => {
    return result.data.data;
  });
};

// export const cancelLoanRequestBySupplier = (
//   data: ReferenceKeyRequest
// ): Promise<boolean> => {
//   return Axios.post<ApiResultModel<boolean>>(
//     ApiBaseUrl + LoanBaseUrl + "/CancelLoanRequestBySupplier",
//     data
//   ).then((result) => {
//     return result.data.data;
//   });
// };

export const getLoanRegistrationWizardInfo = (
  data: ReferenceKeyRequest
): Promise<GetLoanRegistrationWizardInfoResponse> => {
  return Axios.post<ApiResultModel<GetLoanRegistrationWizardInfoResponse>>(
    ApiBaseUrl + Wizard + "/GetLoanRegistrationWizardInfo",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const finalizeRegisteredLoanDocuments = (
  data: ReferenceKeyRequest
): Promise<GetLoanRegistrationWizardInfoResponse> => {
  return Axios.post<ApiResultModel<GetLoanRegistrationWizardInfoResponse>>(
    ApiBaseUrl + Wizard + "/FinalizeRegisteredLoanDocuments",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const cancelLoanRequestBySupplier = (
  data: CancelReason
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + LoanBaseUrl + "/CancelLoanRequestBySupplier",
    data
  ).then((result) => {
    return result.data.data;
  });
};

// detailLoan inforamtion

export const GetLoanInformation = async (
  data: ReferenceKeyRequest
): Promise<ApiResultModel<GetCoreInformationResponse>> => {
  return await Axios.post<ApiResultModel<GetCoreInformationResponse>>(
    ApiBaseUrl + LoanBaseUrl + "/GetLoanInformation",
    data
  ).then((result) => {
    return result.data;
  });
};
//===============================================================new register loan

export const RegisterLoan = async (
  data: IRequestRegisterLoan
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + LoanBaseUrl + "/RegisterLoan",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const InitializeRegistrationParams = async (): Promise<IInitializeRegistrationParamsResponse> => {
  return await Axios.post<
    ApiResultModel<IInitializeRegistrationParamsResponse>
  >(ApiBaseUrl + LoanBaseUrl + "/InitializeRegistrationParams").then(
    (result) => {
      return result.data.data;
    }
  );
};
export const GetRegistrationDuration = async (
  data: ILoanBaseModel
): Promise<IResponse[]> => {
  return await Axios.post<ApiResultModel<IResponse[]>>(
    ApiBaseUrl + LoanBaseUrl + "/GetRegistrationDuration",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetFinancialSuppliersByLoanTemplateAndOrganization = async (
  data: TGetLoanInfo
): Promise<IloanTemplateDetail[]> => {
  const { loanTemplateId, organizationId } = data;

  const url = `${ApiBaseUrl}${LoanBaseUrl}/GetFinancialSuppliersByLoanTemplateAndOrganization/${loanTemplateId}/${organizationId}`;

  return await Axios.get<ApiResultModel<IloanTemplateDetail[]>>(url).then(
    (result) => {
      return result.data.data;
    }
  );
};

export const CalculateLoanParams = async (
  data: ICalculateLoanParamsRequest
): Promise<ICalculateLoanParamsResponse> => {
  return await Axios.post<ApiResultModel<ICalculateLoanParamsResponse>>(
    ApiBaseUrl + LoanBaseUrl + "/CalculateLoanParams",
    data
  ).then((result) => {
    return result.data.data;
  });
};

//=========table
export const GetLoans = async (
  data: IGetLoansRequest
): Promise<ApiResultModel<IGetLoansResponse[]>> => {
  return await Axios.post<ApiResultModel<IGetLoansResponse[]>>(
    ApiBaseUrl + LoanBaseUrl + "/GetLoans",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetLoansReportExcel = async (data: IfilterLoan) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + LoanBaseUrl + "/GetLoansReportExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    response = response.data;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` لیست تسهیلات در جریان.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};
